module.exports = {
  "/view/:presentationId": {
    "success": {
      "public view": [
        "PREVIEW_LOAD"
      ],
      "document not found": [
        "DOCUMENT_NOT_FOUND"
      ]
    },
    "partialSuccess": {
      "page redirected to another hublet": [
        "REDIRECTED_TO_ANOTHER_HUBLET"
      ]
    },
    "error": [
      "PREVIEW_FAIL"
    ]
  }
};